export const DAILY_PHRASES = [
  "Está bien pedir ayuda. No tienes que pasar por todo solo o sola.",
  "Cada día es una nueva oportunidad para ser feliz.",
  "Tus sentimientos son importantes y válidos.",
  "Eres valioso/a tal como eres.",
  "Pequeños pasos te llevan lejos.",
  "El error es parte del aprendizaje.",
  "Mereces amor y respeto.",
  "Tu bienestar es lo más importante.",
  "No estás solo/a en esto.",
  "Cada emoción tiene su propósito.",
  "Eres más fuerte de lo que crees.",
  "Hoy es un buen día para ser amable contigo mismo/a.",
  "Tu voz importa.",
  "Es okay no estar okay a veces.",
  "El cambio comienza con un pequeño paso.",
  "Tienes el poder de cambiar tu día.",
  "Respira profundo, todo va a estar bien.",
  "Eres especial y único/a.",
  "Tu felicidad es importante.",
  "Cada día es un regalo."
];

export const getRandomDailyPhrase = (): string => {
  const today = new Date().toDateString();
  const index = today.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0) % DAILY_PHRASES.length;
  return DAILY_PHRASES[index];
};

export const DAILY_PHRASE = getRandomDailyPhrase();

export const CALMI_INTRO = "¡Hola! Soy Calmi, estoy aquí para ti";

export const CALMI_SUPPORT = "Estoy aquí para escucharte y apoyarte siempre";

export const CHAT_WELCOME = "¡Hola! Soy Michi";

export const CHAT_INSTRUCTIONS = "¡Envíame un mensaje para empezar a conversar!";

export const CHAT_EXAMPLES = [
  "hola",
  "jugar",
  "comida",
  "mimos",
  "dormir",
  "¿cómo estás?",
];
